export function toSlug(str) {
    return (str || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export const BADGE_VB = "0 0 85.29 141.98";
export const BADGE_W  = 85.29;
export const BADGE_H  = 141.98;
 
export const BADGE_META = {
    blue: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Blue-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Blue-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
    green: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Green-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Green-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
    navy: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Navy-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Navy-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
    purple: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Purple-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Purple-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
    yellow: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Yellow-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Yellow-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
    "no color": {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-NoColor-Strain.svg",   qx: 22.03, qy: 22.0, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-NoColor-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    }, 
    mix: {
        vb: BADGE_VB, w: BADGE_W, h: BADGE_H,
        strain:   { file: "DYC-NCBadge-Verified-Mix-Strain.svg",   qx: 22.03, qy: 32.6, qs: 58 },
        noStrain: { file: "DYC-NCBadge-Verified-Mix-NoStrain.svg", qx: 22.03, qy: 22.0, qs: 58 },
    },
};
 